module.exports = __webpack_public_path__ + "img/baohu 1@2x.3882df0c.png";